<template>
  <div>
    <input
      v-model.trim="search"
      ref="search"
      type="text"
      :placeholder="$t('purchaseOrder.searchProductList')"
      class="form-control"
    />
    <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
      <ts-loading-banner :loading="loading">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-w-20">
                {{ $t('purchaseOrder.group') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1">
                {{ $t('purchaseOrder.category') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1">
                {{ $t('purchaseOrder.barcode') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1">
                {{ $t('purchaseOrder.name') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center">
                {{ $t('purchaseOrder.quantity') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center">
                {{ $t('purchaseOrder.cost') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(product, index) in getProduct({
                chosenProduct: model.po_detail,
                search: search
              })"
              :key="index"
              class="ts-cursor-pointer hover:ts-bg-gray-300 ts-border-b"
            >
              <td class="ts-whitespace-no-wrap" @click="addItem(product)">
                {{ product.pro_group_name_en }}
              </td>
              <td class="ts-whitespace-no-wrap" @click="addItem(product)">
                {{ product.category_name_en }}
              </td>
              <td class="ts-whitespace-no-wrap" @click="addItem(product)">
                {{ product.barcode }}
              </td>
              <td class="ts-whitespace-no-wrap" @click="addItem(product)">
                {{ product.product_name_en }}
              </td>
              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="product.qty"
                  @keypress.enter="addItem(product)"
                />
              </td>
              <td
                @click="addItem(product)"
                class="ts-px-4 ts-text-right ts-whitespace-no-wrap"
              >
                {{
                  $defaultCurrencyWithCode(
                    getCostPrice({
                      product_id: product.product_id,
                      uom_id: product.uom_id
                    }),
                    default_precision
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
    <small
      ><i>{{ $t('purchaseOrder.clickToAddProduct') }}</i></small
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'productList',
  props: ['value'],
  data () {
    return {
      loading: false,
      search: '',
      model: {}
    }
  },
  computed: {
    ...mapGetters('purchaseOrder/order', ['getProduct', 'getCostPrice']),
    default_precision () {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
  },
  created () {
    this.model = this.value
  },
  methods: {
    addItem (product) {
      let cost = 0

      if (product.sale_code[0] !== undefined) {
        if (product.sale_code[0].product_price !== undefined) {
          cost = product.sale_code[0].product_price.cost
        }
      }
      this.model.po_detail.push({
        product_id: product.product_id,
        uom_id: product.uom_id,
        uom_cat_id: product.uom_cat_id,
        qty: product.qty ? product.qty : 1,
        maximum_reorder_allow: product.maximum_reorder_allow,
        alloworder: false,
        cost: cost,
        discount_rate: 0,
        discount_type: '%',
        total_after_discount: _.round(cost * (product.qty ? product.qty : 1), 2)
      })
    }
  }
}
</script>

<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
</style>
